"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsSettings = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./PaymentsSettings.css"));
var ModalComponent_1 = __importDefault(require("Modal/ModalComponent"));
var Configuration_1 = require("Styles/Configuration/Configuration");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var GeneralSettings_1 = require("Library/PaymentsDashboard/PaymentSettings/GeneralSettings");
var Permissions_1 = require("Library/PaymentsDashboard/PaymentSettings/Permissions");
var Enable_1 = require("Library/PaymentsDashboard/PaymentSettings/Enable");
var ConnectCallToActionBanner_1 = require("Library/PaymentsDashboard/PaymentSettings/ConnectCallToActionBanner");
var ConnectedGateways_1 = require("Library/PaymentsDashboard/PaymentSettings/ConnectedGateways");
var PaymentsSettings = function (_a) {
    var closeModal = _a.closeModal, paymentsEnabled = _a.paymentsEnabled, setIsOnboardingModalOpen = _a.setIsOnboardingModalOpen;
    return (react_1.default.createElement(ModalComponent_1.default, { className: styles.paymentsModal, containerClassName: styles.modalContainer, contentClassName: styles.modalContent },
        react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex }, function () {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.modalHeader, align: "center", direction: "horizontal", justify: "spaceBetween" },
                    react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", direction: "horizontal", gap: "l" },
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "Payment settings")),
                    react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", direction: "horizontal", gap: "l" },
                        react_1.default.createElement(kaleidoscope_1.Tooltip, __assign({ content: react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "xs" },
                                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" }, "QwilrPay is connected"),
                                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Disconnect your QwilrPay account to connect a new payment gateway")) }, (!paymentsEnabled ? { show: false } : {}), { wrapTarget: true, size: kaleidoscope_1.TooltipSize.Large, position: kaleidoscope_1.TooltipPosition.Bottom }),
                            react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                                    setIsOnboardingModalOpen(true);
                                }, type: kaleidoscope_1.ButtonType.Secondary, disabled: paymentsEnabled }, "Connect payment gateway")),
                        react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: closeModal, buttonState: kaleidoscope_1.ButtonState.Idle }))),
                react_1.default.createElement("div", { className: styles.leftPanelWrapper },
                    react_1.default.createElement(LeftPanel, null)),
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.rightPanelWrapper, align: "center" },
                    react_1.default.createElement(RightPanel, null))));
        })));
};
exports.PaymentsSettings = PaymentsSettings;
var LeftPanel = function () {
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "l" },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Explore settings for payments around permissions and payment methods dynamically based on your configuration. You can also apply custom defaults for payment gateways."),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m" },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Payment gateways"),
            react_1.default.createElement(kaleidoscope_1.Separator, null),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs", align: "center", justify: "start", paddingTop: "s" },
                react_1.default.createElement(icons_1.Disable, { color: "default" }),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "No payment gateways connected")))));
};
var RightPanel = function () {
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", justify: "center", gap: "xl" },
        react_1.default.createElement(ConnectCallToActionBanner_1.ConnectCallToActionBanner, null),
        react_1.default.createElement(Enable_1.Enable, null),
        react_1.default.createElement(ConnectedGateways_1.ConnectedGateways, null),
        react_1.default.createElement(GeneralSettings_1.GeneralSettings, null),
        react_1.default.createElement(Permissions_1.Permissions, null)));
};
